/** Bound how many relative paths we retain before flushing to SQLite (avoids a giant in-memory array). */
export const FILE_INDEX_INSERT_BUFFER = 2048;

/** How often to check shutdown during a sync tree walk (Ctrl+C responsiveness). */
export const FILE_INDEX_INTERRUPT_CHECK_EVERY = 256;
